import React from 'react';

export class ToggleOpened extends React.Component {
   render() {
      return <div className='neo-icon-minus'></div>;
   }
};
